import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=5bc1e1fd&lang=less"
import "./index.vue?vue&type=style&index=1&id=5bc1e1fd&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/www.7pa.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc1e1fd"]])

export default __exports__